import types from '../actions/types';
import produce from 'immer';
import uuidv4 from 'uuid/v4';
import { arrayMove } from 'react-sortable-hoc';
import _each from 'lodash/each';
import _map from 'lodash/map';
import _min from 'lodash/min';
import _max from 'lodash/max';
import _minBy from 'lodash/minBy';
import _maxBy from 'lodash/maxBy';
import _difference from 'lodash/difference';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _values from 'lodash/values';
import _cloneDeep from 'lodash/cloneDeep';

// const initialState = {
//   surfaces: [
//     {
//       "id": 1,
//       "surface": {
//         "id": 6,
//         "name": "背面",
//         "price": 1750,
//         "background": { width: 1000, height: 933 },
//         "canvas": { x: 300, y: 200, width: 400, height: 600 }
//       },
//       "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//       "x": 0,
//       "y": 0,
//       "width": 0,
//       "height": 0
//     },
//     {
//       "id": 2,
//       "surface": {
//         "id": 5,
//         "name": "前面",
//         "price": 1750,
//         "background": { width: 1000, height: 933 },
//         "canvas": { x: 300, y: 200, width: 400, height: 600 }
//       },
//       "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/4bcf3ad1045ed36df33737bb7b9247ec.png",
//       "x": 0,
//       "y": 0,
//       "width": 0,
//       "height": 0
//     },
//     {
//       "id": 3,
//       "surface": {
//         "id": 8,
//         "name": "左袖",
//         "price": 750,
//         "background": { width: 2057, height: 2055, scale: 0.5 },
//         "canvas": { x: 300, y: 200, width: 400, height: 600 }
//       },
//       "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/bf7f237a5c332e3795f9f5914d62742f.png",
//       "x": 0,
//       "y": 0,
//       "width": 0,
//       "height": 0
//     },
//     {
//       "id": 4,
//       "surface": {
//         "id": 7,
//         "name": "右袖",
//         "price": 750,
//         "background": { width: 1000, height: 933 },
//         "canvas": { x: 300, y: 200, width: 400, height: 600 }
//       },
//       "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/da3f3a5532f586c117dde293f73da24f.png",
//       "x": 0,
//       "y": 0,
//       "width": 0,
//       "height": 0
//     }
//   ],
//   currentSurface: {
//     "id": 1,
//     "surface": {
//       "id": 6,
//       "name": "背面",
//       "price": 1750,
//       "background": { width: 1000, height: 933 },
//       "canvas": { x: 300, y: 200, width: 400, height: 600 }
//     },
//     "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//     "x": 0,
//     "y": 0,
//     "width": 0,
//     "height": 0
//   },
//   objects: {
//     1: {
//       '3a017fc5-4f50-4db9-b0ce-4547ba0a1bfd': {
//         id: '3a017fc5-4f50-4db9-b0ce-4547ba0a1bfd',
//         type: 'text',
//         size: {},
//         path: {
//           type: 'curve',
//           strength: 0.5
//         },
//         props: {
//           text: 'テキスト',
//           fill: '#000000',
//           fontFamily: 'Arial',
//           x: 10,
//           y: 10,
//           scaleX: 1,
//           scaleY: 1
//         }
//       },
//       'fdda765f-fc57-5604-a269-52a7df8164ec': {
//         id: 'fdda765f-fc57-5604-a269-52a7df8164ec',
//         type: 'text',
//         size: {},
//         props: {
//           text: 'テキスト2',
//           fill: '#ff0000',
//           fontFamily: 'Arial',
//           x: 50,
//           y: 50,
//           scaleX: 2,
//           scaleY: 2
//         }
//       },
//       '3bbcee75-cecc-5b56-8031-b6641c1ed1f1': {
//         id: '3bbcee75-cecc-5b56-8031-b6641c1ed1f1',
//         type: 'image',
//         src: 'https://placehold.it/256x340',
//         name: 'image.png',
//         size: {},
//         props: {
//           x: 100,
//           y: 100,
//           width: 256,
//           height: 340
//         }
//       },
//       'F29325DB-D900-4E41-AB0C-F7F8AFFC3A50': {
//         id: 'F29325DB-D900-4E41-AB0C-F7F8AFFC3A50',
//         type: 'group',
//         objects: {
//           'ED732BFB-2E11-4B6B-A5B7-9E9A25CB083B': {
//             id: 'ED732BFB-2E11-4B6B-A5B7-9E9A25CB083B',
//             type: 'text',
//             size: {},
//             props: {
//               text: 'Inner text',
//               fill: '#000000',
//               fontFamily: 'Arial',
//               x: 50,
//               y: 90,
//               scaleX: 1,
//               scaleY: 1
//             }
//           },
//           '93A3DEED-F6C7-4A32-B64B-962B3A5F32C3': {
//             id: '93A3DEED-F6C7-4A32-B64B-962B3A5F32C3',
//             type: 'text',
//             size: {},
//             props: {
//               text: 'Inner text 2',
//               fill: '#000000',
//               fontFamily: 'Arial',
//               x: 100,
//               y: 130,
//               scaleX: 1,
//               scaleY: 1
//             }
//           },
//         },
//         index: [
//           'ED732BFB-2E11-4B6B-A5B7-9E9A25CB083B',
//           '93A3DEED-F6C7-4A32-B64B-962B3A5F32C3'
//         ]
//       }
//     },
//     2: {},
//     3: {},
//     4: {}
//   },
//   index: {
//     1: [
//       '3a017fc5-4f50-4db9-b0ce-4547ba0a1bfd',
//       'fdda765f-fc57-5604-a269-52a7df8164ec',
//       '3bbcee75-cecc-5b56-8031-b6641c1ed1f1'
//     ],
//     2: [],
//     3: [],
//     4: []
//   }
// };

const haveIntersection = (r1, r2) => {
  return !(
    r2.props.x > r1.props.x + (r1.props.width * r1.props.scaleX) ||
    r2.props.x + (r2.props.width * r2.props.scaleX) < r1.props.x ||
    r2.props.y > r1.props.y + (r1.props.height * r1.props.scaleY) ||
    r2.props.y + (r2.props.height * r2.props.scaleY) < r1.props.y
  );
};

const testCollision = (object, siblings) => {
  let intersection = [];
  _each(siblings, (sibling) => {
    if (object.intersectionAvailable === false || sibling.intersectionAvailable === false) {
      if (haveIntersection(object, sibling)) {
        intersection.push(sibling);
      }
    }
  });

  if (intersection.length > 0) {
    intersection.push(object);
  }

  return intersection;
};

const initialState = window.tProjectGlobals.initialStates.objects;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.ADD_NEW_TEXT_OBJECT:
      return produce(state, draftState => {
        const id = action.payload.uuid || uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;

        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        draftState.objects[surfaceId][id] = {
          id: id,
          type: 'text',
          props: {
            text: '',
            fill: '#000000',
            fontFamily: 'sourcehansansr',
            x: 10,
            y: 10,
            scaleX: 1.5,
            scaleY: 1.5
          },
          font: {label: '源ノ角ゴシック', value: 'sourcehansansr', bold: 'sourcehansansb', fontplus: false, lang: 'ja'},
        };
        draftState.index[surfaceId].push(id);
      });
    case types.ADD_NEW_TEMPLATE_TEXT:
      return produce(state, draftState => {
        const id = action.payload.uuid || uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;
        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        draftState.objects[surfaceId][id] = {
          id: id,
          type: 'text',
          props: action.payload.props,
          font: {label: '源ノ角ゴシック', value: 'sourcehansansr', bold: 'sourcehansansb', fontplus: false, lang: 'ja'},
        };
        draftState.index[surfaceId].push(id);

      });
    case types.ADD_NEW_IMAGE_OBJECT:
      return produce(state, draftState => {
        const id = uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;

        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        let scale = 1.0;
        if (action.payload.object.width > draftState.currentSurface.surface.canvas.width) {
          scale = draftState.currentSurface.surface.canvas.width / action.payload.object.width;
        }
        if (action.payload.object.height > draftState.currentSurface.surface.canvas.height) {
          scale = Math.min(scale, draftState.currentSurface.surface.canvas.height / action.payload.object.height);
        }

        draftState.objects[surfaceId][id] = {
          id: id,
          type: 'image',
          src: action.payload.object.src,
          name: action.payload.object.name,
          size: {},
          props: {
            x: 0,
            y: 0,
            width: action.payload.object.width,
            height: action.payload.object.height,
            scaleX: scale,
            scaleY: scale
          }
        };
        draftState.index[surfaceId].push(id);
      });
    case types.ADD_NEW_TEMPLATE_IMAGE:
      return produce(state, draftState => {
        const id = action.payload.uuid || uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;

        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        draftState.objects[surfaceId][id] = {
          id: id,
          type: 'image',
          src: action.payload.props.src,
          name: action.payload.name,
          size: {},
          props: action.payload.props
        };
        draftState.index[surfaceId].push(id);
      });
    case types.ADD_NEW_STICKER_OBJECT:
      return produce(state, draftState => {
        const id = uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;

        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        const attr = {
          id: id,
          type: 'sticker',
          src: action.payload.sticker.image,
          name: action.payload.sticker.title,
          size: {},
          props: {
            x: (draftState.currentSurface.surface.canvas.width / 4),
            y: (draftState.currentSurface.surface.canvas.height / 4),
            width: (draftState.currentSurface.surface.canvas.width / 2),
            //height: 255,
            scaleX: 1,
            scaleY: 1
          },
          paths: (action.payload.sticker.paths || []),
          rotateEnabled: action.payload.sticker.restriction.is_rotatable,
          resizeEnabled: action.payload.sticker.restriction.is_resizable,
          keepRatio: action.payload.sticker.restriction.keep_ratio,
          intersectionAvailable: action.payload.sticker.restriction.is_overlay_available
        };

        if ((action.payload.sticker.vector || false)) {
          attr.props['fill'] = '#000000';
          attr.props.scaleX = 0.5;
          attr.props.scaleY = 0.5;
        }

        attr.props['height'] = attr.props.width / parseFloat((action.payload.sticker.ratio || 1));

        const collision = testCollision(attr, _values(draftState.objects[surfaceId]));
        //const hasCollision = collision.length > 0;

        draftState.objects[surfaceId][id] = attr;
        draftState.index[surfaceId].push(id);
        draftState.collision = collision;
      });
    case types.SELECT_OBJECT:
    case types.SELECT_OBJECT_MULTIPLE:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        draftState.objects[surfaceId][action.payload.id].size = action.payload.size;
      });
    case types.TRANSFORM_OBJECT:
      return produce(state, draftState => {
        const id = action.payload.name;
        const surfaceId = draftState.currentSurface.surface.id;

        const test = produce(state.objects[surfaceId][id], draftTest => {
          draftTest.props = {
            ...draftTest.props,
            ...action.payload
          };
        });

        const collision = testCollision(test, _values(_filter(draftState.objects[surfaceId], (o) => o.id !== test.id)));
        const hasCollision = collision.length > 0;
        draftState.collision = collision;

        draftState.objects[surfaceId][id] = produce(state.objects[surfaceId][id], draftObject => {
          draftObject.props = {
            ...draftObject.props,
            ...action.payload
          };
          draftObject.collision = hasCollision;
        });
      });
    case types.MOVE_OBJECT:
      return produce(state, draftState => {
        const id = action.payload.id;
        const surfaceId = draftState.currentSurface.surface.id;

        const test = produce(state.objects[surfaceId][id], draftTest => {
          draftTest.props = {
            ...draftTest.props,
            x: action.payload.diffX,
            y: action.payload.diffY
          };
        });

        const collision = testCollision(test, _values(_filter(draftState.objects[surfaceId], (o) => o.id !== test.id)));
        const hasCollision = collision.length > 0;
        draftState.collision = collision;

        draftState.objects[surfaceId][id] = produce(state.objects[surfaceId][id], draftObject => {
          draftObject.props = {
            ...draftObject.props,
            x: action.payload.diffX,
            y: action.payload.diffY
          };
          draftObject.collision = hasCollision;
        });
      });
    case types.DELETE_TEMPLATE_OBJECT:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;
        delete draftState.objects[surfaceId][action.payload.id];
        draftState.index[surfaceId] = _difference(draftState.index[surfaceId], [action.payload.id]);
      });
    case types.DELETE_OBJECT:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;
        _each(action.payload.id, id => {
          delete draftState.objects[surfaceId][id];
        });
        draftState.index[surfaceId] = _difference(draftState.index[surfaceId], action.payload.id);
      });
    // case types.DELETE_TEMPLATE_OBJECT:
    //   return produce(state, draftState => {
    //     const surfaceId = draftState.currentSurface.surface.id;
    //     _each(action.payload.id, id => {
    //       delete draftState.objects[surfaceId][id];
    //     });
    //     draftState.index[surfaceId] = _difference(draftState.index[surfaceId], action.payload.id);
    //   });
    case types.SORT_LAYER:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;
        const index = state.index[surfaceId].slice().reverse();
        draftState.index[surfaceId] = arrayMove(index, action.payload.oldIndex, action.payload.newIndex).reverse();
      });
    case types.UPDATE_OBJECT_SIZES:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        _each(action.payload.sizes, (value, key) => {
          draftState.objects[surfaceId][key].size = value;

          if (state.objects[surfaceId][key].type === 'text' && state.objects[surfaceId][key].path) {
            const object = draftState.objects[surfaceId][key];
            //console.log(value);
            const mx = object.props.x;
            const my = object.props.y + object.size.height;
            const ex = object.props.x + object.size.width;
            const ey = my;

            const cx = (object.size.width / 3);
            const cyMin = my - (object.size.width / 5);
            const cyMax = my - (object.size.width / 2);
            const cyBuffer = cyMin - cyMax;
            const cyFactor = cyBuffer * object.path.strength;
            const cy = cyMin + cyFactor;
            const c1x = mx + cx;
            const c2x = ex - cx;

            draftState.objects[surfaceId][key].props.data = `M${mx},${my} C${c1x},${cy} ${c2x},${cy} ${ex},${ey}`;
          }
        });
      });
    case types.ALIGN_HORIZONTAL_LEFT:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        const x = _map(action.payload.ids, id => {
          return state.objects[surfaceId][id].props.x;
        });

        const minX = _min(x);

        _each(action.payload.ids, id => {
          draftState.objects[surfaceId][id].props.x = minX;
        })
      });
    case types.ALIGN_HORIZONTAL_CENTER:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        const lr = _map(action.payload.ids, id => {
          return {
            left: state.objects[surfaceId][id].props.x,
            right: state.objects[surfaceId][id].props.x + (state.objects[surfaceId][id].size.width || 0)
          }
        });

        const minX = _minBy(lr, 'left');
        const maxX = _maxBy(lr, 'right');
        const center = minX.left + ((maxX.right - minX.left) / 2);

        _each(action.payload.ids, id => {
          const c = state.objects[surfaceId][id].props.x + (state.objects[surfaceId][id].size.width / 2);
          const diff = center - c;
          draftState.objects[surfaceId][id].props.x = state.objects[surfaceId][id].props.x + diff;
        });
      });
    case types.ALIGN_HORIZONTAL_RIGHT:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        const right = _map(action.payload.ids, id => {
          return state.objects[surfaceId][id].props.x + state.objects[surfaceId][id].size.width;
        });

        const maxX = _max(right);

        _each(action.payload.ids, id => {
          const diff = maxX - (state.objects[surfaceId][id].props.x + state.objects[surfaceId][id].size.width);
          draftState.objects[surfaceId][id].props.x += diff;
        })
      });
    case types.ALIGN_VERTICAL_TOP:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        const y = _map(action.payload.ids, id => {
          return state.objects[surfaceId][id].props.y;
        });

        const minY = _min(y);

        _each(action.payload.ids, id => {
          draftState.objects[surfaceId][id].props.y = minY;
        })
      });
    case types.ALIGN_VERTICAL_BOTTOM:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        const bottom = _map(action.payload.ids, id => {
          return state.objects[surfaceId][id].props.y + state.objects[surfaceId][id].size.height;
        });

        const maxY = _max(bottom);

        _each(action.payload.ids, id => {
          const diff = maxY - (state.objects[surfaceId][id].props.y + state.objects[surfaceId][id].size.height);
          draftState.objects[surfaceId][id].props.y += diff;
        })
      });
    case types.EDIT_OBJECT:
    case types.EDIT_FONT:
      return produce(state, draftState => {
        const surfaceId = draftState.currentSurface.surface.id;

        _each(action.payload.diff, (v, k) => {
          draftState.objects[surfaceId][action.payload.id].props[k] = v;
        });

        if (action.payload.font) {
          draftState.objects[surfaceId][action.payload.id].font = action.payload.font;
        }
      });
    case types.SELECT_SURFACE:
      return produce(state, draftState => {
        draftState.currentSurface = action.payload.surface;
        //console.log(action.payload.surface);
      });
    case types.SELECT_COLOR:
      return produce(state, draftState => {
        // current selected surface
        const currentSelected = draftState.currentSurface.surface.id;

        draftState.surfaces = action.payload.color.images;

        draftState.currentSurface = _find(action.payload.color.images, (obj) => {
          return obj.surface.id === currentSelected;
        });
      });
    case types.COPY_OBJECT:
      return produce(state, draftState => {
        const id = action.payload.uuid || uuidv4();
        const surfaceId = draftState.currentSurface.surface.id;

        if (!draftState.objects[surfaceId]) {
          draftState.objects[surfaceId] = {};
        }

        let copy = _cloneDeep(action.payload.object);
        copy.id = id;
        copy.props.x = copy.props.x + 20;
        copy.props.y = copy.props.y + 20;
        copy.props.name = id;
        // copy.props = produce(copy.props, draft => {
        //   draft.x = draft.x + 20;
        //   draft.y = draft.y + 20;
        // });
        draftState.objects[surfaceId][id] = copy;
        draftState.index[surfaceId].push(id);
      });
    case types.FLIP_OBJECT_HORIZONTAL:
      return produce(state, draftState => {
        const id = action.payload.id;
        const surfaceId = draftState.currentSurface.surface.id;

        draftState.objects[surfaceId][id] = produce(state.objects[surfaceId][id], draftObject => {
          const scaleX = (draftObject.props.scaleX || 1) * -1;
          draftObject.props = {
            ...draftObject.props,
            scaleX: scaleX,
            // x: (scaleX < 0) ? (draftObject.props.x + draftObject.props.width) : (draftObject.props.x - draftObject.props.width),
            x: draftObject.props.x - (draftObject.props.width * scaleX)
          };
        });
      });
    case types.FLIP_OBJECT_VERTICAL:
      return produce(state, draftState => {
        const id = action.payload.id;
        const surfaceId = draftState.currentSurface.surface.id;

        draftState.objects[surfaceId][id] = produce(state.objects[surfaceId][id], draftObject => {
          const scaleY = (draftObject.props.scaleY || 1) * -1;

          draftObject.props = {
            ...draftObject.props,
            scaleY: scaleY,
            y: draftObject.props.y - (draftObject.props.height * scaleY)
          };
        });
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/objectsReducer.js